import React, { useEffect, useState,useRef } from "react";
import ConsultantLayout from "../../commonlayouts/consultantlayout";
import SubscriptionStatus from "../../commonlayouts/subscriptionstatus";
import { Link } from "react-router-dom";
import { GetCandidateStats,Searchfilter,GetbenchSalesSubmissions,GetBenchsaalesStats } from "../../apiconstants/constants";
import axios from "axios";
import { useCountry } from "../../contexts/countrycodecontext.js";
import BenchSalesBarGraph from "../benchsalesbargraph.js";
import OverallRecruiterBarGraph from "../overallrecruiterbargraph.js";
import TodaySubmissionCountCard from "./todaysubmissioncountcard.js";
import Select from "react-select";
import { useUserType, selectedUserType } from "../../contexts/usertypecontext.js";

const Dashboard = () => {
<style>
{`
  /* Striped row color */
  .dashboard-teal-striped {
    --bs-table-striped-bg: rgba(0, 167, 172, 0.06);
    --bs-table-striped-color: #000;
  }

  /* FORCE hover on each cell */
  .dashboard-teal-striped tbody tr:hover td {
    background-color: rgba(0, 167, 172, 0.14) !important;
  }
`}
</style>


  const {selectedCountry} = useCountry();
const { selectedUserType } = useUserType();

  const roleID = parseInt(localStorage.getItem("roleID"));
  const isSubscriptionActive = localStorage.getItem("isSubscriptionActive");

 const normalizedUserType = (selectedUserType|| "")
  .toLowerCase()
  .replace(/\s+/g, "")
  .trim();


const isRecruiterUser = normalizedUserType.includes("recruiter");
const isBenchSales = normalizedUserType.includes("benchsales");
const isDualRoleUser =
  normalizedUserType.includes("recruiter") &&
  normalizedUserType.includes("benchsales");
const isAdmin = roleID === 2;
const canToggle = isAdmin || (isRecruiterUser && isBenchSales); 

const [activeMode, setActiveMode] = useState(
  isBenchSales ? "bench" : "recruiter"
);


const resolvedMode = (() => {
  const type = (selectedUserType || "")
    .toLowerCase()
    .replace(/\s+/g, "");

  return type === "benchsales" ? "bench" : "recruiter";
})();


console.log("Normalized User Type =", normalizedUserType);
const [stats, setStats] = useState({
  totalSubmissions: 0,
  interviewScheduled: 0,
  selected: 0,
  totalJobPosts: 0
});
const token = localStorage.getItem("jwtToken");
  let Guid="";
 
  const guid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid")
// const email = "avanthikaa@knackhook.com"
 const email = localStorage.getItem("email");

  const [candidates, setCandidates] = useState([]);
const [isTableLoading, setIsTableLoading] = useState(false);

const modeRef = useRef(resolvedMode);
const [allReportCandidates, setAllReportCandidates] = useState([]);
const [allBenchCandidates, setAllBenchCandidates] = useState([]);

const showDualTodayCard = isAdmin || (isRecruiterUser && isBenchSales);
const [benchStatsData, setBenchStatsData] = useState([]);

const totals = benchStatsData.reduce(
  (acc, curr) => {
    acc.totalSubmissions += curr.overallCount || 0;
    acc.interviewScheduled += curr.interviewsScheduled || 0;
    acc.offersExtended += curr.offersReleased || 0;

    return acc;
  },
  {
    totalSubmissions: 0,
    interviewScheduled: 0,
    offersExtended: 0,
  }
);



useEffect(() => {
  modeRef.current = resolvedMode;
}, [resolvedMode]);

 
  if(roleID==3){
   Guid = employerGuid
  }
  else{
    Guid= guid
  }
  const isToday = (dateStr) => {
  if (!dateStr) return false;
  const d = new Date(dateStr);
  const t = new Date();

  return (
    d.getDate() === t.getDate() &&
    d.getMonth() === t.getMonth() &&
    d.getFullYear() === t.getFullYear()
  );
};

 const dateFilterOptions = [
    { value: "Past 7 days", label: "Past 7 days" },
    { value: "Past 30 days", label: "Past 30 days" },
    { value: "This month", label: "This month" },
    { value: "Past 6 months", label: "Past 6 months" },
    { value: "Past 1 year", label: "Past 1 year" },
    { value: "Past 2 years", label: "Past 2 years" },
    { value: "Past 3 years", label: "Past 3 years" },
  ];
 const [selectedDateFilter, setSelectedDateFilter] = useState({
  value: "This month",
  label: "This month",
});


const fetchDashboardCandidates = async () => {
  if (!selectedCountry || !Guid) return;

  const modeAtCallTime = resolvedMode;   // 🔒 freeze mode

  setIsTableLoading(true);

  const token = localStorage.getItem("jwtToken");

  try {
    let res;

    if (modeAtCallTime === "bench") {
      res = await axios.get(`${GetbenchSalesSubmissions.APIURL}?benchSalesGuid=${guid}&dateFilter=${selectedDateFilter.value}&Usertype=Benchsales`, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } else {
      res = await axios.post(Searchfilter.APIURL, {
        json: JSON.stringify({
          UserGuid: Guid,
          CountryID: selectedCountry,
          SubmittedDate: selectedDateFilter.value
        }),
        type: "Reports"
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
    }

    // ⛔ discard stale response
    if (modeRef.current !== modeAtCallTime) return;
const fullData =
  modeAtCallTime === "bench"
    ? res.data?.submissions || []
    : res.data || [];

// 🔒 cache per mode
if (modeAtCallTime === "bench") {
  setAllBenchCandidates(fullData);
} else {
  setAllReportCandidates(fullData);
}
    const data =
      modeAtCallTime === "bench"
        ? (res.data?.submissions || []).slice(0, 10)
        : (res.data.filter(item => !item.isSummary) || [])?.slice(0, 10);

    setCandidates(data);
  } catch (err) {
    console.error(err);
  } finally {
    if (modeRef.current === modeAtCallTime)
      setIsTableLoading(false);
  }
};
useEffect(() => {
  if (!normalizedUserType) return;

  if (normalizedUserType.includes("benchsales")) {
    setActiveMode("bench");
  } else {
    setActiveMode("recruiter");
  }
}, [normalizedUserType]);
useEffect(() => {
  console.log("Dropdown userType →", normalizedUserType);
  console.log("Resolved mode →", resolvedMode);
}, [normalizedUserType, resolvedMode]);

useEffect(() => {
  const fetchKpiStats = async () => {
    try {
      setIsTableLoading(true);

      const res = await axios.get(GetCandidateStats.APIURL, {
        params: {
          guid: Guid,
          DateFilter: selectedDateFilter.value,
          CountryID: selectedCountry,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setBenchStatsData(res.data || []);
    } catch (err) {
      console.error("Error fetching KPI stats:", err);
      setBenchStatsData([]);
    } finally {
      setIsTableLoading(false);
    }
  };

  if (Guid && selectedDateFilter.value) fetchKpiStats();
}, [Guid, selectedDateFilter.value, token, selectedCountry]);

useEffect(() => {
  if (!selectedCountry || !Guid) return;

  const modeAtCallTime = resolvedMode;

  const callAllDashboardApis = async () => {
    try {
      setIsTableLoading(true);

      await Promise.all([
        axios.get(GetCandidateStats.APIURL, {
          params: {
            guid: Guid,
            CountryID: selectedCountry,
            DateFilter: selectedDateFilter.value
          },
          headers: { Authorization: `Bearer ${token}` }
        }).then(res => setStats(res.data)),

        fetchDashboardCandidates()
      ]);
    } finally {
      if (modeRef.current === modeAtCallTime) {
        setIsTableLoading(false);
      }
    }
  };

  callAllDashboardApis();
}, [selectedDateFilter, selectedCountry, Guid, resolvedMode]);

// useEffect(() => {
//   setActiveGraph(resolvedMode);
// }, [resolvedMode]);
useEffect(() => {
  setCandidates([]);          // clear old table
  setIsTableLoading(true);    // show loader immediately
}, [selectedDateFilter, resolvedMode]);

const tableRows = candidates.map((item, index) => {
  if (resolvedMode === "bench") {
    return {
      _key: `bench-${item.submissionID}-${index}`,
      name: item.candidateName || "-",
      job: item.jobRoleName || "-",
      client:
        item.staffingContactCompanyName ||
        item.staffingContactName ||
        "-"
    };
  }

  return {
    _key: `recruiter-${item.guid || item.candidatesID}-${index}`,
    name: item.fullName || "-",
    job: item.jobTitle || item.jobRoleName || "-",
    client:
      item.vendorCompanyName && item.vendorName
        ? `${item.vendorCompanyName} - ${item.vendorName}`
        : item.vendorCompanyName || item.vendorName || "-"
  };
});


 
  // -----------------------------
  // ✅ DYNAMIC DASHBOARD CARDS LIST (stored inside component)  roleid : 2 -admin, 3 -user
  // -----------------------------
 const dashboardCards = [
  { title: "Post a Job", icon: "fas fa-briefcase", link: "/Employer/ListOfJobPosts", hideFor: ["bench sales"] },
 
  // Candidate Pool (dynamic link)
  {
    title: "Candidate Pool",
    icon: "fa fa-users",
    link: normalizedUserType === "benchsales"
  ? "/Employer/InternalBench"
  : "/Employer/GetCandidatesByEmployerUserID",

  },
 
  { title: "AI Resume Insights", icon: "fas fa-briefcase", link: "/Employer/AIResumeInsights" },
  { title: "Job Roles", icon: "fas fa-briefcase", link: "/Employer/JobRoles" },
  { title: "Question Bank", icon: "fa fa-question", link: "/Employer/Questions", hideFor: ["bench sales"] },
 
  { title: "Scheduled Interviews", icon: "fa fa-bell", link: "/Employer/GetInterviewScheduledCandidates" },
  { title: "Completed Interviews", icon: "fa fa-clock", link: "/Employer/GetInterviewCompletedCandidates" },
 
{
  title: "Client Directory",
  icon: "fas fa-user-tie",
  link: "/Employer/ListofClients",
  hideFor: ["recruiter", "bench sales"]
},
  { title: "Staffing Contacts", icon: "fa fa-fire", link: "/Employer/ListofStaffingContacts" },
 
  // Reports (Dynamic)
  {
    title:
  normalizedUserType === "recruiter"
    ? "Reports"
    : normalizedUserType === "benchsales"
    ? "Bench Sales Reports"
    : "Reports",

link:
  normalizedUserType === "recruiter"
    ? "/Employer/Reports?type=recruiter"
    : normalizedUserType === "benchsales"
    ? "/Employer/ViewBenchSalesReports"
    : "/Employer/Reports",

  },
 
  { title: "LinkedIn Contacts", icon: "fab fa-linkedin", link: "/Employer/ListofLinkedInContacts" },
  { title: "Resources", icon: "fa fa-file", link: "/Employer/ListofResources" },
 
  // Dice Search (hidden for BenchSales)
  {
    title: "Dice Search",
    customIcon: true,
    link: "/Employer/DiceSearch",
    hideFor: ["bench sales"]
  },
 
  {
  title: "Internal Bench",
  icon: "fa fa-users",
  link: "/Employer/InternalBench",
 
 
}
 
];
 
 
  return (
    <ConsultantLayout>
      <SubscriptionStatus />
 
      {isSubscriptionActive === "false" ? (
        <p style={{ minHeight: 400 }}></p>
      ) : (
        <div className="container-fluid">
          <div className="row mt-3">
            <div className="col-sm-12 col-lg-6">
              <h2 style={{ color: "#00a7ac" }}>Dashboard</h2>
            </div>
          </div>
 
          <hr />
          <div className="row mb-3">
  

    <div className="row mb-3">
  <div className="col-12 d-flex justify-content-end align-items-center gap-2">

   
    {/* 📅 Date Filter */}
    <Select
      options={dateFilterOptions}
      value={selectedDateFilter}
      onChange={setSelectedDateFilter}
      styles={{
        control: (base) => ({
          ...base,
          minHeight: 36,
          fontSize: 12,
          width: 200,
        }),
      }}
    />
  </div>
</div>

  </div>
          {/* -----------------------------
              ✅ DYNAMIC CARD RENDERING
              ----------------------------- */}
              {!isBenchSales && (
  <div className="row mt-3">
  {[
    { title: "Total Submissions", value: totals.totalSubmissions, icon: "fa fa-paper-plane" },   

    { title: "Interviews Scheduled", value: totals.interviewScheduled, icon: "fa fa-calendar-check" },

    { title: "Offers Extended", value: totals.offersExtended, icon: "fa fa-trophy" },

     { title: "Active Jobs", value: benchStatsData.length > 0 ? benchStatsData[0].totalJobPosts : 0, icon: "fa fa-briefcase" },

  ].map((item, i) => (
    <div key={i} className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-3">
      <div className="kpi-card">

        <div className="kpi-icon">
          <i className={item.icon}></i>
        </div>

        <div className="kpi-value">
          {item.value}
        </div>

        <div className="kpi-title">
          {item.title}
        </div>

      </div>
    </div>
  ))}
</div>
)}


            
 {/* ===============================
    📊 DASHBOARD TABLE SECTION
================================ */}
<div className="row  ">
 
<div className="col-lg-8 col-12">
 
{/* Graphs – ALWAYS visible */}
<div className="card shadow-sm mt-2">
  {/* Toggle Buttons – SHOW ONLY FOR ADMIN OR DUAL ROLE */}
 {resolvedMode === "bench" ? (
  <BenchSalesBarGraph
    key={`bench-${resolvedMode}-${selectedDateFilter.value}`}
    dateFilter={selectedDateFilter.value}
  />
) : (
  <OverallRecruiterBarGraph
    key={`recruiter-${resolvedMode}-${selectedDateFilter.value}`}
    dateFilter={selectedDateFilter.value}
  />
)}


 

</div>


</div>


  <div className="col-lg-4 col-12 mt-2">
    <div className="card shadow-sm">
      

      <div
        className="card-header text-white"
       style={{    backgroundColor: "#00a7ac", fontSize: "14px", padding: "8px 12px"  }}
      >
<strong>
 {resolvedMode === "bench"
  ? "Bench Sales Submissions"
  : "Recruiter Reports"}

</strong>
      </div>

      <div className="card-body p-0">
    <table className="table table-striped dashboard-teal-striped mb-0">


          <thead style={{ fontSize: "13px" }}>
            <tr>
              <th> Full Name</th>
              <th>Job Role</th>
              <th>Client Name</th>
            </tr>
          </thead>

        <tbody style={{ fontSize: "12.5px" }}>
  {isTableLoading ? (
    <tr>
      <td colSpan="3" className="text-center">
        Loading...
      </td>
    </tr>
  ) : tableRows.length > 0 ? (
    tableRows.map((row, i) => (
<tr key={row._key}
        style={{
          backgroundColor:
            i % 2 === 0 ? "rgba(0, 167, 172, 0.06)" : "transparent",
          cursor: "pointer"
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor =
            "rgba(0, 167, 172, 0.14)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor =
            i % 2 === 0
              ? "rgba(0, 167, 172, 0.06)"
              : "transparent";
        }}
      >
        <td>{row.name}</td>
        <td>{row.job}</td>
        <td>{row.client}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="3" className="text-center">
        No records found
      </td>
    </tr>
  )}
</tbody>

        </table>
      </div>
    </div>
  </div>
</div>
  


{/* Tiles */}
         {/* <div className="row mt-4">
  {dashboardCards
.filter(card => {
  if (
      card.title === "Internal Bench" &&
      roleID === 3 &&
      isRecruiterUser &&
      !isBenchSales
    ) {
      return false;
    }
       // existing hideFor logic
    if (!card.hideFor || !userType) return true;
    
  return !card.hideFor.some(h =>
    h.replace(/\s+/g, "").toLowerCase() === userType
  );
})
 
 
    .map((card, index) => (
      <div key={card.title} className="col-sm-12 col-lg-4 col-xl-4">
        <Link to={card.link}>
          <div
            className="card shadow-sm p-3 text-center mt-3"
            style={{
              borderTop: "4px solid #00a7ac",
              borderRadius: "20px",
              borderLeft: "none",
              borderRight: "none",
              borderBottom: "none",
              height: "150px",
            }}
          >
            <div className="text-center">
              {card.customIcon ? (
                <div
                  style={{
                    backgroundColor: "#00a7ac",
                    color: "white",
                    fontSize: "20px",
                    fontWeight: "bold",
                    width: "30px",
                    height: "30px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "8px",
                  }}
                >
                  D
                </div>
              ) : (
                <i
                  className={`${card.icon} mt-2`}
                  style={{ color: "#00a7ac", fontSize: "30px" }}
                ></i>
              )}
            </div>
 
            <h4>{card.title}</h4>
          </div>
        </Link>
      </div>
    ))}
</div>
  */}

      
  </div>

       
      )}
    </ConsultantLayout>
  );
};
 
export default Dashboard;